'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { formatSoldCount } from './helper'
import { useProductCardContext } from './context/product-card-context'

export const ProductItemRating = () => {
  const { product } = useProductCardContext()
  const t = useTranslations('product_detail.title')

  const rating = useMemo(() => {
    const avg = product?.review?.avg
    if (!avg) return null
    return Math.round((avg / 2) * 10) / 10
  }, [product?.review?.avg])

  const soldProduct = product?.sold_product ?? 0

  if (!rating && soldProduct <= 0) return null

  return (
    <div className='flex shrink-0 items-center gap-1.5 lg:gap-2'>
      {rating ? (
        <div className='flex items-center gap-0.5 lg:gap-1'>
          <Image
            src='/icons/product/icon-star-gold.svg'
            width={12}
            height={12}
            alt='rating'
            className='h-3 w-3 lg:h-3.5 lg:w-3.5'
          />
          <span className='font-sans text-xs font-medium leading-3.5 text-neutral-700 lg:text-sm lg:leading-4.5'>
            {rating.toFixed(1)}
          </span>
        </div>
      ) : null}

      {rating && soldProduct > 0 ? (
        <span className='h-3 w-px bg-neutral-300 lg:h-3.5' aria-hidden />
      ) : null}

      {soldProduct > 0 ? (
        <span className='font-sans text-xs leading-3.5 text-neutral-600 lg:text-sm lg:leading-4.5'>
          {t('sold_product')} {formatSoldCount(soldProduct)}
        </span>
      ) : null}
    </div>
  )
}
